import { useState, useEffect, useRef } from 'react';

const WaffleChart = ({ chartdata, disabled, containerHeight }) => {

    const [gridSize, setGridSize] = useState(0);
    const ref = useRef(null);

    useEffect(() => {
        const element = ref?.current;

        if (!element) return;

        const observer = new ResizeObserver(() => {
            setGridSize(element.clientHeight);
        });


        observer.observe(element);
        return () => {
            observer.disconnect();
        };

    }, []);


    // const colors = ["#2caffe", "#544fc5", "#00e272", "#fe6a35", "#6b8abc", "#d568fb", "#2ee0ca", "#fa4b42"];
    const colors = ["#7bafd4", "#db8925", "#fdd773", "#6c345f", "#62b1bd", "#8a8d32", "#6f625a", "#6f625a", "#4c7289"];
    const grayColors = ["#eee", "#ddd", "#ccc", "#bbb", "#aaa", "#999", "#888", "#777"];

    let cells = [];
    let row = 1;
    let column = 1;

    if (chartdata.data !== undefined) {
        for (let s = 0, series = chartdata.data.length; s < series; s++) {
            for (let square = 0, squares = chartdata.data[s].value; square < squares; square++) {
                let x = (row % 2 === 1 ? (column - 1) : 10 - column) / 10;
                let y = (10 - row) / 10;
                let colorIndex = s % 8;
                cells.push({
                    x: `${(100 * x).toFixed(2)}%`,
                    y: `${(100 * y).toFixed(2)}%`,
                    width: "10%",
                    height: "10%",
                    fill: disabled ? grayColors[colorIndex] : colors[colorIndex]
                });
                column++;
                if (column > 10) {
                    column = 1;
                    row++;
                }
            }
        }
    }

    return (
        <div className="waffle-container" style={{ height: `${containerHeight}px` }}>
            <div ref={ref} className="waffle-chart">
                <svg xmlns="http://www.w3.org/2000/svg" width={gridSize} height={gridSize}>
                    <g stroke="none">
                        {
                            cells.map((cell, i) => {
                                return (
                                    <rect key={i} x={cell.x} y={cell.y} height={cell.height} width={cell.width} fill={cell.fill} />
                                )
                            })
                        }
                    </g>
                    <g fill="none" stroke="white">
                        <line x1="0" x2="100%" y1="10%" y2="10%" />
                        <line x1="0" x2="100%" y1="20%" y2="20%" />
                        <line x1="0" x2="100%" y1="30%" y2="30%" />
                        <line x1="0" x2="100%" y1="40%" y2="40%" />
                        <line x1="0" x2="100%" y1="50%" y2="50%" />
                        <line x1="0" x2="100%" y1="60%" y2="60%" />
                        <line x1="0" x2="100%" y1="70%" y2="70%" />
                        <line x1="0" x2="100%" y1="80%" y2="80%" />
                        <line x1="0" x2="100%" y1="90%" y2="90%" />
                        <line x1="10%" x2="10%" y1="0" y2="100%" />
                        <line x1="20%" x2="20%" y1="0" y2="100%" />
                        <line x1="30%" x2="30%" y1="0" y2="100%" />
                        <line x1="40%" x2="40%" y1="0" y2="100%" />
                        <line x1="50%" x2="50%" y1="0" y2="100%" />
                        <line x1="60%" x2="60%" y1="0" y2="100%" />
                        <line x1="70%" x2="70%" y1="0" y2="100%" />
                        <line x1="80%" x2="80%" y1="0" y2="100%" />
                        <line x1="90%" x2="90%" y1="0" y2="100%" />
                    </g>
                </svg>
            </div>
            <div className={`waffle-legend ${disabled ? "disabled" : ""}`} disabled={disabled}>
                {
                    chartdata.data?.map((series, i) => {
                        return (
                            <label key={i}>{series.name}</label>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default WaffleChart
